<template>
  <div>
    <md-empty-state
      style="min-width: 410px"
      class="md-primary md-small"
      md-icon="done"
      md-label="Done"
      :md-description="description"
    ></md-empty-state>
  </div>
</template>

<script>
export default {
  name: "ActionIsDone",
  props: {
    description: String,
  },
  data: function () {
    return {};
  },
};
</script>

<style>
</style>